import React from 'react'
import "./login.css";
import { useSelector } from 'react-redux';
import { Navigate } from "react-router-dom";

const Login = () => {
  const user = useSelector((state) => state.user);
  return (user ? (<Navigate to="/home" replace={true}/>) : (
    <div className="lpm__loginpage-label">
      <label>Please login using your protagonist.co google email!</label>
    </div> )
  )
}

export default Login